import React from 'react';
import classnames from 'classnames';

import Constraint from '../../01-atoms/Constraint/Constraint';
import Text from '../../01-atoms/Text/Text';

import './Section.css';

const Section = ({ children, className, semanticLevel = 1, title }) => (
  <section className={classnames(`Section`, className)}>
    <Constraint>
      {!!title && (
        <header className="Section__header">
          <Text semanticLevel={semanticLevel}>{title}</Text>
        </header>
      )}

      {!!children && <div className="Section__body">{children}</div>}
    </Constraint>
  </section>
);

export default Section;
